import { Input } from '../../../../shared/components/FormControls';
import Rodal from 'rodal';
import { Button } from '../../../../shared/components/Button';
import '../../../../shared/styles/Orchestrator.css';
import 'rodal/lib/rodal.css';
import { useEffect, useState } from 'react';
import { DEFAULT_GRID_COLS, DEFAULT_GRID_ROWS } from '../../utils/gridConfig';

function GridConfigModal({
  visible,
  gridConfig,
  onCancel,
  onSave,
  mode = 'light',
}) {
  const isDark = mode === 'dark';
  const [isPhone, setIsPhone] = useState(false);
  const [cols, setCols] = useState(String(gridConfig.cols ?? DEFAULT_GRID_COLS));
  const [rows, setRows] = useState(String(gridConfig.rows ?? DEFAULT_GRID_ROWS));
  const [type, setType] = useState(gridConfig.type ?? 'square');

  // Sync form when gridConfig changes (e.g. modal re-opens)
  useEffect(() => {
    if (visible) {
      setCols(String(gridConfig.cols ?? DEFAULT_GRID_COLS));
      setRows(String(gridConfig.rows ?? DEFAULT_GRID_ROWS));
      setType(gridConfig.type ?? 'square');
    }
  }, [visible, gridConfig]);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 620px)');
    const handler = () => setIsPhone(mq.matches);
    handler();
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const parsedCols = Math.max(1, Math.min(100, parseInt(cols, 10) || DEFAULT_GRID_COLS));
  const parsedRows = Math.max(1, Math.min(100, parseInt(rows, 10) || DEFAULT_GRID_ROWS));

  const handleSave = () => {
    onSave({ cols: parsedCols, rows: parsedRows, type });
  };

  const labelStyle = {
    fontSize: '12px',
    fontWeight: 600,
    marginBottom: '4px',
  };

  return (
    <Rodal
      animation='slideUp'
      visible={visible}
      onClose={onCancel}
      className={isDark ? 'df_rodal_dark' : ''}
      customStyles={{
        border: isDark ? '2px solid var(--onyx)' : '2px solid #e4e7c5',
        backgroundColor: isDark ? 'var(--jet)' : '#f6f7eb',
        color: isDark ? 'var(--ivory)' : 'var(--jet)',
        width: isPhone ? 'calc(100% - 34px)' : 400,
        height: isPhone ? 'calc(100% - 114px)' : 350,
        marginTop: isPhone ? '80px' : '',
      }}
    >
      <div
        className={`trialment_login_form${isDark ? ' df_modal_form_dark' : ''}`}
        style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
      >
        <div style={{ flex: 1, overflowY: isPhone ? 'auto' : 'visible' }}>
          <div
            className='trialment_login_form_row'
            style={{ fontWeight: 700, fontSize: 16, marginBottom: 6, textAlign: 'center' }}
          >
            Grid Configuration
          </div>

          {/* Grid Type */}
          <div className='trialment_login_form_row'>
            <div style={labelStyle}>Grid Type</div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <Button
                label='Square'
                type={type === 'square' ? 'cinnabar' : 'black-white'}
                onPress={() => setType('square')}
              />
              <Button
                label='Hexagonal'
                type={type === 'hex' ? 'cinnabar' : 'black-white'}
                onPress={() => setType('hex')}
              />
            </div>
          </div>

          {/* Grid Dimensions */}
          <div className='trialment_login_form_row' style={{ marginTop: 12 }}>
            <div style={labelStyle}>Grid Size</div>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'nowrap' }}>
              <label style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <span style={{ fontSize: '11px', fontWeight: 600, opacity: 0.7 }}>Columns</span>
                <Input
                  type='number'
                  min={1}
                  max={100}
                  value={cols}
                  onChange={(e) => setCols(e.target.value)}
                  className='grid-config-dimension'
                />
              </label>
              <label style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <span style={{ fontSize: '11px', fontWeight: 600, opacity: 0.7 }}>Rows</span>
                <Input
                  type='number'
                  min={1}
                  max={100}
                  value={rows}
                  onChange={(e) => setRows(e.target.value)}
                  className='grid-config-dimension'
                />
              </label>
            </div>
          </div>

          {/* Info text */}
          <div
            className='trialment_login_form_row'
            style={{ fontSize: '12px', opacity: 0.65 }}
          >
            {type === 'hex'
              ? 'Hexagonal mode: token sizes are 1, 3, 7, or 12 hexes. Distance uses hex steps (1 hex = 5 ft).'
              : `Square mode: default is ${DEFAULT_GRID_COLS} columns × ${DEFAULT_GRID_ROWS} rows. Each square = 5 ft.`}
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 10,
            marginTop: 8,
            marginBottom: 8,
          }}
        >
          <Button
            label='Cancel'
            type={isDark ? 'onyx' : 'black-white'}
            onPress={onCancel}
          />
          <Button
            label='Save'
            type='cinnabar'
            onPress={handleSave}
          />
        </div>
      </div>
    </Rodal>
  );
}

export default GridConfigModal;
